import {
    OPTICIAN_SET_FILTERED_STORES,
    OPTICIAN_SET_STORES,
    OPTICIAN_SET_PAGE_COUNT,
    OPTICIAN_SET_CURRENT_PAGE,
    OPTICIAN_SET_CURRENT_CATEGORY,
    OPTICIAN_SET_DISPLAYED_STORES,
    OPTICIAN_SET_NAME_FIELTER,
    OPTICIAN_USER_GEOLOCATION,
    OPTICIAN_SET_ORDER
} from '../Actions/Opticians.action';

const defaultState = {
    title: '',
    subTitle: '',
    groupTitle: '',
    categories: [],
    displayedStores: [],
    currentStores: [],
    filteredStores: [],
    pageCount: 1,
    currentPage: 1,
    currentCategory: undefined,
    searchString: '',
    order: 'NAME_ASC',
    coords: {}
}


export const opticians = (state = defaultState, { type, payload }) => {
    switch (type) {
        case OPTICIAN_SET_STORES:
        case OPTICIAN_SET_NAME_FIELTER:
        case OPTICIAN_SET_FILTERED_STORES:
        case OPTICIAN_SET_CURRENT_PAGE:
        case OPTICIAN_SET_PAGE_COUNT:
        case OPTICIAN_USER_GEOLOCATION:
        case OPTICIAN_SET_CURRENT_CATEGORY:
        case OPTICIAN_SET_DISPLAYED_STORES:
        case OPTICIAN_SET_ORDER:
            return { ...state, ...payload }
        default:
            return state;
    }
}